import RefDataCollection from './ref-data-collection';
import RefDataModel from './ref-data-model';
import RefDataEnum from './ref-data-enum';

export default {
  Collection: RefDataCollection,
  Enum:       RefDataEnum,
  Model:      RefDataModel,
};
